export default {
  APPLE: 'Apple',
  JO_MALONE: 'Jo Malone London',
  CLEARABEE: 'Clearabee',
};
